<template>
  <div class="service-card">
    <img
      :src="service.photo"
      width="200px"
      height="150px"
      style="object-fit: cover; border-radius: 4px"
      alt="service image"
    />
    <v-row no-gutters style="margin-top: 24px">
      <v-col cols="6" class="px-0 py-0">
        <div class="service-details">
          <h4 class="service-title">{{ service.service_name_de }}</h4>
          <p
            v-for="(service, index) in service.text_points"
            :key="service.id"
            style="margin-top: 10px; margin-bottom: 0px"
          >
            <span style="font-weight: 600">Пункт {{ index + 1 }}:</span>
            {{ service.text }}
          </p>
        </div>
      </v-col>

      <v-row no-gutters justify="end">
        <admin-submit-button
          @click="$emit('setItemForEdit', service)"
          height="38px"
        >
          <v-icon color="#FFFFFF" style="margin-right: 4px"
            >mdi-pencil-outline</v-icon
          >
          Редагувати</admin-submit-button
        >
        <admin-submit-button
          @click="showConfirmDeleteModal = true"
          style="background: #d32f2f; margin-left: 10px"
        >
          <v-icon color="#FFFFFF" style="margin-right: 4px"
            >mdi-delete-outline</v-icon
          >
          Видалити</admin-submit-button
        >
      </v-row>
    </v-row>
    <confirm-delete-modal
      v-if="showConfirmDeleteModal"
      :visible="showConfirmDeleteModal"
      title="Видалити послугу"
      text="Ви впевнені, що хочете видалити цю послугу? Цю дію не можна скасувати."
      @close="showConfirmDeleteModal = false"
      @confirm="
        $emit('deleteService', service.id), (showConfirmDeleteModal = false)
      "
    />
  </div>
</template>

<script>
import AdminSubmitButton from "../../UI/Btns/adminSubmitButton.vue";
import ConfirmDeleteModal from "../../UI/Modals/confirmDeleteModal.vue";

export default {
  components: {
    AdminSubmitButton,
    ConfirmDeleteModal,
  },
  data: () => ({
    showConfirmDeleteModal: false,
  }),
  props: {
    service: {
      required: true,
    },
  },
};
</script>

<style scoped>
.service-card {
  padding: 15px 10px;
  color: #1d1d1d;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  border-radius: 10px;
  border: 1px solid #e7e7e7;
  background: #fff;
  display: flex;
  margin-bottom: 15px;
}
.service-details {
  margin-left: 20px;
}
</style>